import { useEffect, useRef, useState } from 'react';
import { API, APIMethod } from '@brg/api';

type ApiLoading = boolean;
type ApiError = string | undefined | number;

interface ResponsePaging {
    count: number;
}

export type UseAPIMethodReturn<T> = [T | undefined, ApiLoading, ApiError, ResponsePaging | undefined];

export const useAPIMethod = <T, K>(
    method: APIMethod<K, unknown>,
    args: K,
    lang = 'en',
    t?: unknown,
    disabled?: boolean,
    setIsLoadingExt?: (isLoading: boolean) => void
): UseAPIMethodReturn<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState<T>();
    const [paging, setPaging] = useState<ResponsePaging>();
    const [raw, setRaw] = useState<unknown>();
    const abortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        (async () => {
            if (!disabled) {
                setIsLoading(true);
                if (setIsLoadingExt) setIsLoadingExt(true)
            }
            try {
                if(!args || disabled) {
                    return
                }
                const res = await method(args as any, { signal: controller.signal });
                if (controller.signal.aborted) return;
                const json = (await res.json()) as any;
                if (controller.signal.aborted) return;
                setRaw(json);
                setError(undefined);
                if (json.status && json.status === 404) {
                    setError(json.status);
                }
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError') return;
                if (controller.signal.aborted) return;
                setError((e as string) ?? 'error');
            }
        })();

        return () => {
            controller.abort();
        };
    }, [disabled, t, setIsLoadingExt]);

    useEffect(() => {
        if (raw && !error) {
            setResponse(API.toLang(raw, lang) as T);
            const rawResponse: any = raw
            setPaging(rawResponse?.paging);
        } else {
            setResponse(undefined);
        }
    }, [raw, lang, error]);

    useEffect(() => {
        if ((response && raw) || error) {
            setIsLoading(false);
            if (setIsLoadingExt) setIsLoadingExt(false)
        }
    }, [response, raw, error]);

    return [response, isLoading, error, paging];
};
import { useEffect, useRef, useState } from 'react';
import { API, APIMethod } from '@brg/api';

type ApiLoading = boolean;
type ApiError = string | undefined | number;

interface ResponsePaging {
    count: number;
}

export type UseAPIMethodReturn<T> = [T | undefined, ApiLoading, ApiError, ResponsePaging | undefined];

export const useAPIMethod = <T, K>(
    method: APIMethod<K, unknown>,
    args: K,
    lang = 'en',
    t?: unknown,
    disabled?: boolean,
    setIsLoadingExt?: (isLoading: boolean) => void
): UseAPIMethodReturn<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState<T>();
    const [paging, setPaging] = useState<ResponsePaging>();
    const [raw, setRaw] = useState<unknown>();
    const abortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        (async () => {
            if (!disabled) {
                setIsLoading(true);
                if (setIsLoadingExt) setIsLoadingExt(true)
            }
            try {
                if(!args || disabled) {
                    return
                }
                const res = await method(args as any, { signal: controller.signal });
                if (controller.signal.aborted) return;
                const json = (await res.json()) as any;
                if (controller.signal.aborted) return;
                setRaw(json);
                setError(undefined);
                if (json.status && json.status === 404) {
                    setError(json.status);
                }
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError') return;
                if (controller.signal.aborted) return;
                setError((e as string) ?? 'error');
            }
        })();

        return () => {
            controller.abort();
        };
    }, [disabled, t, setIsLoadingExt]);

    useEffect(() => {
        if (raw && !error) {
            setResponse(API.toLang(raw, lang) as T);
            const rawResponse: any = raw
            setPaging(rawResponse?.paging);
        } else {
            setResponse(undefined);
        }
    }, [raw, lang, error]);

    useEffect(() => {
        if ((response && raw) || error) {
            setIsLoading(false);
            if (setIsLoadingExt) setIsLoadingExt(false)
        }
    }, [response, raw, error]);

    return [response, isLoading, error, paging];
};
